import { useEffect } from 'react'
import { useConfirmStore } from './confirmStore'

/**
 * Единственный экземпляр диалога подтверждения. Монтируется в App.
 * Читает текущий запрос из useConfirmStore и резолвит промис по клику.
 * Визуал — как у прежнего ResetConfirmDialog (единый стиль CRM).
 */
export function ConfirmHost() {
  const current = useConfirmStore((s) => s.current)
  const settle = useConfirmStore((s) => s.settle)

  useEffect(() => {
    if (!current) return
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') settle(false)
      if (e.key === 'Enter') settle(true)
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [current, settle])

  if (!current) return null

  const confirmBg = current.danger ? '#dc2626' : '#2563eb'

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9998,
      }}
      onClick={() => settle(false)}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: '28px 32px',
          maxWidth: 420,
          width: '100%',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            fontSize: 15,
            fontWeight: 600,
            color: '#111827',
            marginBottom: current.message ? 10 : 24,
            whiteSpace: 'pre-line',
          }}
        >
          {current.title}
        </div>
        {current.message && (
          <div
            style={{
              fontSize: 13,
              color: '#6b7280',
              marginBottom: 24,
              whiteSpace: 'pre-line',
            }}
          >
            {current.message}
          </div>
        )}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            onClick={() => settle(false)}
            style={{
              padding: '7px 18px',
              fontSize: 13,
              border: '1px solid #d1d5db',
              borderRadius: 8,
              cursor: 'pointer',
              background: '#fff',
              color: '#374151',
            }}
          >
            {current.cancelText ?? 'Отмена'}
          </button>
          <button
            onClick={() => settle(true)}
            style={{
              padding: '7px 18px',
              fontSize: 13,
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              background: confirmBg,
              color: '#fff',
            }}
          >
            {current.confirmText ?? 'Да'}
          </button>
        </div>
      </div>
    </div>
  )
}
